import { Tooltip } from 'antd'
import React from 'react'

const RescheduleIcon = () => {
  return (
    <Tooltip title="Reschedule">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 1.87305L13.7456 1.87307V0.627441C13.7456 0.282129 13.4659 0.00244141 13.1206 0.00244141C12.7753 0.00244141 12.4956 0.282129 12.4956 0.627441V1.87275H7.49563V0.627441C7.49563 0.282129 7.21594 0.00244141 6.87063 0.00244141C6.52531 0.00244141 6.24563 0.282129 6.24563 0.627441V1.87275H1.25C0.559687 1.87275 0 2.43244 0 3.12275V18.7478C0 19.438 0.559687 19.9978 1.25 19.9978H18.75C19.4403 19.9978 20 19.438 20 18.7478V3.12275C20 2.43273 19.4403 1.87305 18.75 1.87305ZM18.75 18.7478H1.25V3.12275H6.24563V3.75244C6.24563 4.09773 6.52531 4.37744 6.87063 4.37744C7.21594 4.37744 7.49563 4.09773 7.49563 3.75244V3.12307H12.4956V3.75275C12.4956 4.09807 12.7753 4.37775 13.1206 4.37775C13.4659 4.37775 13.7456 4.09807 13.7456 3.75275V3.12307H18.75V18.7478Z"
          fill="#3249D7"
        />
        <g clipPath="url(#clip0_121_1415)">
          <path
            d="M6.91991 11.1427C7.00579 11.0649 7.0535 11.0163 7.10121 10.9677C7.38747 10.7149 7.80732 10.7247 8.07449 10.9872C8.34167 11.2399 8.38938 11.6774 8.14129 11.9594C7.63556 12.5038 7.11075 13.0385 6.5764 13.5538C6.32831 13.7969 5.92754 13.7677 5.67945 13.5247C5.17373 13.0288 4.67754 12.5233 4.1909 12.0177C3.91419 11.726 3.94281 11.2885 4.20999 11.0066C4.47716 10.7344 4.90655 10.7247 5.20235 10.9872C5.26915 11.0552 5.33594 11.133 5.42182 11.2302C5.47907 10.9385 5.5077 10.676 5.57449 10.4233C6.08022 8.6441 7.20617 7.52604 8.98098 7.20521C10.8035 6.88437 12.3302 7.52604 13.3035 9.13021C15.0879 12.0566 13.2176 15.4497 10.2596 15.8385C9.38174 15.9552 8.56113 15.8094 7.76915 15.401C7.33022 15.1774 7.17754 14.7594 7.36838 14.3705C7.55922 13.9816 7.98861 13.8649 8.418 14.0885C10.126 14.9635 12.1298 13.9913 12.5306 12.1052C12.855 10.5788 11.8436 9.00382 10.3359 8.69271C8.75197 8.36215 7.19663 9.40243 6.91991 10.9872C6.91991 11.026 6.91991 11.0649 6.91991 11.1427Z"
            fill="#3249D7"
          />
        </g>
        <defs>
          <clipPath id="clip0_121_1415">
            <rect
              width="10"
              height="8.75"
              fill="white"
              transform="translate(4 7.12744)"
            />
          </clipPath>
        </defs>
      </svg>
    </Tooltip>
  )
}

export default RescheduleIcon
